import request from './request'
import * as http from '@/libs/http'

/**
 * メールアドレスの確認メールを送信する
 *
 * @param {String} orgcode 組織コード
 * @param {Object} data ログイン情報
 * @returns {Response} レスポンスデータ
 */
export function verifyEmail (orgcode, email) {
  return request.post(`/org/${orgcode}/verify/email`, {
    email
  }, {
    validateStatus: (status) => [
      http.OK,
      http.Conflict,
      http.Forbidden
    ].includes(status)
  })
}
